export default "__VITE_ASSET__CaIhNdud__"